import { AuditEntityFieldDefinition } from 'O3_audit';
import enAuditFields from './locales/en/audit-fields.json';
import roAuditFields from './locales/ro/audit-fields.json';

/** Billing / fiscal-receipt flow entities audited by core-api financials. */
export const FINANCIALS_AUDIT_DEFINITIONS: AuditEntityFieldDefinition[] = [
  { entityType: 'Payment' },
  { entityType: 'SalesDocument' },
  { entityType: 'SalesDocumentLine' },
  { entityType: 'FiscalNetLog' },
  // Lives in patient-management server-side; surfaced in financials as the
  // provided-services list, so its labels ship with the billing flow.
  { entityType: 'PatientMedicalService' },
];

export const FINANCIALS_AUDIT_TRANSLATIONS = {
  en: enAuditFields as Record<string, unknown>,
  ro: roAuditFields as Record<string, unknown>,
};
